"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _omitBy = _interopRequireDefault(require("lodash/omitBy"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
/**
 * Utilities for working with urls.
 * @module UrlUtils
 */
const UrlUtils = {
  /**
   * Takes a url string and returns an object of query params
   * @static
   * @function parseParams
   * @param {String} queryString - The url or url query string to parse
   * @example
   * UrlUtils.parseParams('?foo=bar'); // {foo: 'bar'}
   * @returns {Object} - The object of query param keys and values.
   */
  parseParams(queryString) {
    if (!queryString) return {};
    const params = new URLSearchParams(this.getQueryString(queryString));
    const paramObj = {};
    for (const [key, value] of params.entries()) {
      this.convertAndAddParamPair(paramObj, key, value);
    }
    return paramObj;
  },
  /**
   * Creates a query string representation of an object, stripping out nullish values.
   * @static
   * @function createQueryString
   * @param {Object} obj - The object to create query string from.
   * @example
   * ObjectUtils.createQueryString({foo: 'hello', baz: 'there'});
   * @returns {String} - The query string output.
   */
  createQueryString(obj) {
    return new URLSearchParams((0, _omitBy.default)(obj, (value, key) => (0, _isNil.default)(key) || (0, _isNil.default)(value) || key.length === 0 || value.length === 0)).toString();
  },
  /**
   * Takes a url string and returns just query string portion
   * @static
   * @function getQueryString
   * @param {String} url - A url to strip
   * @example
   * UrlUtils.getQueryString('http://spothero.com?foo=bar'); // 'foo=bar'
   * @returns {String} - The query string portion of the url
   */
  getQueryString(urlString) {
    let cleanedString = urlString;
    if (cleanedString.indexOf('?') > -1) {
      cleanedString = cleanedString.split('?')[1];
    }
    if (cleanedString.indexOf('#') > -1) {
      cleanedString = cleanedString.split('#')[1];
    }
    if (cleanedString.indexOf('=') === -1 && cleanedString.indexOf('&') === -1) {
      return '';
    }
    while (cleanedString.indexOf('#') === 0 || cleanedString.indexOf('?') === 0) {
      cleanedString = cleanedString.substr(1);
    }
    return cleanedString;
  },
  /**
   * Set deep nested values in an object based on a string selector
   * @static
   * @see {@link https://github.com/stretchr/arg.js/blob/master/src/arg.js#L74|Original Implementation}
   * @function convertAndAddParamPair
   * @param {Object} obj - Object to set selector on
   * @param {Mixed} selector - Object selector ie foo[0][1].bar[0].baz.foobar
   * @param {String} value - Value to set leaf located at `selector` to
   * @example
   * ObjectUtils.convertAndAddParamPair({foo: 'bar'}, 'spots[0].selected', 'true'); // {foo, 'bar', spots: [{selected: true}]}
   * @return {Object} - the manipulated object with new selector & value added
   */
  convertAndAddParamPair(obj, selector, value) {
    let selectorBreak = -1;
    const coerceTypes = {
      true: true,
      false: false,
      null: null,
      undefined: undefined // eslint-disable-line no-undefined, object-shorthand
    };
    let newValue = value;

    // selector could be a number if we're at a numerical index leaf in which case selector.search is not valid
    if (typeof selector === 'string' || Object.prototype.toString.call(selector) === '[object String]') {
      selectorBreak = selector.search(/[\.\[]/);
    }

    // No dot or array notation so we're at a leaf, set value
    if (selectorBreak === -1) {
      if (newValue && !isNaN(newValue)) {
        newValue = Number(newValue);
      } else if (Object.prototype.hasOwnProperty.call(coerceTypes, newValue)) {
        newValue = coerceTypes[newValue];
      }
      return obj[selector] = newValue;
    }

    // Example:
    // selector     = 'foo[0].bar.baz[2]'
    // currentRoot  = 'foo'
    // nextSelector = '0].bar.baz[2]' -> will be converted to '0.bar.baz[2]' in below switch statement
    const currentRoot = selector.substr(0, selectorBreak);
    let nextSelector = selector.substr(selectorBreak + 1);
    switch (selector.charAt(selectorBreak)) {
      case '[':
        // Initialize node as an array if we haven't visited it before
        obj[currentRoot] = obj[currentRoot] || [];
        nextSelector = nextSelector.replace(']', '');
        if (nextSelector.search(/[\.\[]/) === -1 && nextSelector.search(/^[0-9]+$/) > -1) {
          nextSelector = parseInt(nextSelector, 10);
        }
        return this.convertAndAddParamPair(obj[currentRoot], nextSelector, newValue);
      case '.':
        // Initialize node as an object if we haven't visited it before
        obj[currentRoot] = obj[currentRoot] || {};
        return this.convertAndAddParamPair(obj[currentRoot], nextSelector, newValue);
    }
    return obj;
  }
};
var _default = exports.default = UrlUtils;